const BattleCalc = require('../../BattleCalc');

const getNodeWithLowestF = (list, nodeData) => {
  var low_f_index = 0;

  for (let i = 0; i < list.length; ++i) {
    const currentF = nodeData.get(list[i].uid).f;
    const lowestF = nodeData.get(list[low_f_index].uid).f;
    if (currentF < lowestF) {
      low_f_index = i;
    }
  }

  return list[low_f_index];
};

const buildPath = (destinationNode, startNode, nodeData) => {
  var path = [];
  var node = destinationNode;

  // starting with the destination node ...
  path.push(destinationNode);

  // ... walk backwards through the parents we assigned
  while (node.uid !== startNode.uid) {
    node = nodeData.get(node.uid).parent;
    path.unshift(node);
  }

  return path;
};

const removeFromOpenList = (openList, node) => {
  for (var i = 0; i < openList.length; ++i) {
    if (node === openList[i]) {
      openList.splice(i, 1);
    }
  }
};

const isOnOpenList = (openList, node) => {
  for (var i = 0; i < openList.length; ++i) {
    if (node.uid === openList[i].uid) {
      return true;
    }
  }
  return false;
};

const isOnClosedList = (closedList, node) => {
  for (var i = 0; i < closedList.length; ++i) {
    if (node.uid === closedList[i].uid) {
      return true;
    }
  }
  return false;
};

const getPath = (startNode, destinationNode, battleState) => {
  if (!startNode || !destinationNode) {
    return [];
  }

  var openList = [];
  var closedList = [];
  var nodeData = new Map();

  openList.push(startNode);
  nodeData.set(startNode.uid, { g: 0, h: 0, f: 0, parent: null });

  var attempts = 0;

  while (openList.length > 0 && ++attempts < 1000) {
    var currentNode = getNodeWithLowestF(openList, nodeData);

    if (currentNode === destinationNode) {
      // end case - we can build our path
      return buildPath(destinationNode, startNode, nodeData);
    }

    // normal case - move currentNode to the closed list...
    removeFromOpenList(openList, currentNode);
    closedList.push(currentNode);

    //...and process its neighbors
    var adjacentNodes = battleState.getAdjacentTiles(currentNode);

    for (const testNode of adjacentNodes) {
      if (
        !testNode ||
        (testNode.occupied && testNode.uid !== destinationNode.uid) ||
        isOnClosedList(closedList, testNode)
      ) {
        // no need to process this node
        continue;
      }

      // g is the total cost it took for us to get from the startNode to our testNode
      var currentData = nodeData.get(currentNode.uid);
      var g = currentData.g + BattleCalc.boardDistance(currentNode, testNode);
      var best_g = false;

      if (!isOnOpenList(openList, testNode)) {
        // first time we've evaluated this node
        best_g = true;
        var h = BattleCalc.boardDistance(testNode, destinationNode);
        nodeData.set(testNode.uid, { g, h, f: g + h, parent: currentNode });
        openList.push(testNode);
      } else {
        var testData = nodeData.get(testNode.uid);
        if (g < testData.g) {
          // we've already evaluated this node, but last time we gave it a worse g value
          best_g = true;
        }

        if (best_g) {
          testData.g = g;
          testData.f = g + testData.h;
          testData.parent = currentNode;
        }
      }
    }
  }

  // no result was found - there's no path
  return [];
};

module.exports = getPath;
